<template>
    <div>
        <v-toolbar flat color="grey lighten-4">
            <v-btn v-if="!readonly" class="ml-2" @click="createNewPrivateClassDialog = true">
                <v-icon>mdi-plus</v-icon>
                Create Private Class
            </v-btn>
            <v-btn v-if="!readonly"  class="ml-2" @click="addAttendeeToClassDialog = true">
                <v-icon>mdi-plus</v-icon>
                Add Attendee To Class
            </v-btn>
        </v-toolbar>

        <v-card v-for="trainingClass in classes" :key="trainingClass.id">
            <validation-observer
                    :ref=" 'observer-'+trainingClass.id"
            >
                <v-card-title>
                    <h3>{{trainingClass.title}} - CL-{{trainingClass.id}}</h3>


                    <v-spacer/>

                    <v-btn
                            v-if="!readonly && editClass == trainingClass.id"
                            :disabled="editClass === false"
                            @click="openImport(trainingClass)"
                    >
                        <v-icon>mdi-file</v-icon>
                        Import Names
                    </v-btn>


                    <v-btn
                            :to="{name:'training-class', params:{id: trainingClass.id}}"
                            class="ml-2"
                    >
                        View Class
                    </v-btn>


                    <v-btn
                            v-if="!readonly && editClass !== trainingClass.id"
                            :disabled="editClass !== false"
                            class="ml-2"
                            @click="editClass = trainingClass.id"
                    >
                        <v-icon>mdi-pencil</v-icon>
                        Edit
                    </v-btn>

                    <v-btn v-if="!readonly && editClass === trainingClass.id"
                           class="ml-2"
                           color="success"
                           dark
                           @click="saveAttendees(trainingClass.id)"
                    >
                        <v-icon>mdi-pencil</v-icon>
                        Save
                    </v-btn>

                </v-card-title>
                <v-card-subtitle>

                        <v-chip
                                color="blue"
                                dark
                                label
                                class="mr-2"
                        >
                            <v-icon left>mdi-calendar</v-icon>{{trainingClass.firstSessionDate | formatDate}}
                        </v-chip>
                        <v-chip
                                color="indigo"
                                dark
                                label
                                class="mr-2"
                        >
                            <v-icon left>mdi-school-outline</v-icon>{{trainingClass.trainer.firstName}} {{trainingClass.trainer.lastName}}
                        </v-chip>
                       <v-chip
                                color="cyan"
                                dark
                                label
                                class="mr-2"
                        >
                            <v-icon left>fas fa-map-pin</v-icon>{{trainingClass.location}}
                        </v-chip>
                        <v-chip
                                :color="trainingClass.status === 'completed' ? 'green' : 'amber'"
                                dark
                                label
                                class="mr-2"
                        >
                            <v-icon left>fas fa-certificate</v-icon>{{trainingClass.status}}
                        </v-chip>

                </v-card-subtitle>

                <v-card-text>
                    <v-simple-table>
                        <v-simple-table>
                            <template v-slot:default>
                                <thead>
                                <tr>
                                    <th class="text-left">First Name</th>
                                    <th class="text-left">Last Name</th>
                                    <th class="text-left">Email</th>
                                    <th class="text-left">Lab User</th>
                                    <th class="text-left">Lab Pass</th>
                                    <th class="text-left" v-if="editClass === trainingClass.id">Actions</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="attendee in trainingClass.attendees" :key="attendee.id">
                                    <td>
                                        <v-text-field
                                                v-model="attendee.firstName"
                                                label="First Name"
                                                dense
                                                solo
                                                single-line
                                                :hide-details="editClass !== trainingClass.id"
                                                :flat="editClass !== trainingClass.id"
                                                :readonly="editClass !== trainingClass.id"
                                                :disabled="attendee.delete"
                                        />

                                    </td>
                                    <td>
                                        <validation-provider
                                                v-slot="{ errors }"
                                                name="Last Name"
                                                rules="required"
                                        >
                                            <v-text-field
                                                    v-model="attendee.lastName"
                                                    label="Last Name *"
                                                    dense
                                                    solo
                                                    single-line
                                                    :hide-details="editClass !== trainingClass.id"
                                                    :error-messages="errors"
                                                    :flat="editClass !== trainingClass.id"
                                                    :readonly="editClass !== trainingClass.id"
                                                    :disabled="attendee.delete"
                                            />
                                        </validation-provider>
                                    </td>
                                    <td>
                                        <validation-provider
                                                v-slot="{ errors }"
                                                name="Email"
                                                rules="email"
                                        >
                                            <v-text-field
                                                    v-model="attendee.email"
                                                    label="Email"
                                                    type="email"
                                                    dense
                                                    solo
                                                    single-line
                                                    :error-messages="errors"
                                                    :hide-details="editClass !== trainingClass.id"
                                                    :flat="editClass !== trainingClass.id"
                                                    :readonly="editClass !== trainingClass.id"
                                                    :disabled="attendee.delete"
                                            />
                                        </validation-provider>
                                    </td>
                                  <td>

                                        <v-text-field
                                                v-model="attendee.labUser"
                                                label="Lab User"
                                                type="text"
                                                counter="255"
                                                dense
                                                solo
                                                single-line
                                                :hide-details="editClass !== trainingClass.id"
                                                :flat="editClass !== trainingClass.id"
                                                :readonly="editClass !== trainingClass.id"
                                                :disabled="attendee.delete"
                                        />
                                    </td>
                                  <td>

                                    <v-text-field
                                      v-model="attendee.labPass"
                                      label="Lab Pass"
                                      type="text"
                                      counter="255"
                                      dense
                                      solo
                                      single-line
                                      :hide-details="editClass !== trainingClass.id"
                                      :flat="editClass !== trainingClass.id"
                                      :readonly="editClass !== trainingClass.id"
                                      :disabled="attendee.delete"
                                    />
                                  </td>
                                    <td v-if="editClass === trainingClass.id">
                                        <v-btn
                                                v-if="!attendee.delete"
                                                @click="removeAttendee(attendee.bookingIndex)"
                                        >
                                            Delete
                                        </v-btn>
                                        <v-btn
                                                v-if="attendee.delete"
                                                @click="unRemoveAttendee(attendee.bookingIndex)"
                                        >
                                            Restore
                                        </v-btn>

                                    </td>

                                </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-simple-table>
                </v-card-text>
                <v-card-actions>
                    <v-btn
                            v-if="editClass === trainingClass.id"
                            class="ml-2"
                            @click="addAttendee(trainingClass)"
                            text
                    >
                        <v-icon>mdi-plus</v-icon>
                        Add attendee
                    </v-btn>
                </v-card-actions>
            </validation-observer>
        </v-card>

        <v-dialog
                v-model="importAttendeesDialog"
                max-width="890"
        >
            <v-card>
                <v-card-title class="headline">
                    Import Attendees From List
                </v-card-title>

                <v-card-text>
                    <AttendeeListImporter
                            v-model="importAttendees"
                            @complete="importAttendeesDialog = false"
                    />
                </v-card-text>

            </v-card>
        </v-dialog>
        <v-dialog
                v-model="createNewPrivateClassDialog"
                max-width="890"
        >
            <v-card>
                <v-card-title class="headline">
                    Create New Private Class
                </v-card-title>

                <v-card-text>
                    <CreateTrainingClass
                            :booking="booking"
                            :create="createClass"
                            @complete="completeCreateTrainingClass"
                    />
                </v-card-text>

            </v-card>
        </v-dialog>
        <v-dialog
                v-model="addAttendeeToClassDialog"
                max-width="890"
        >
            <v-card>
                <v-card-title class="headline">
                    Add Attendee To Class
                </v-card-title>

                <v-card-text>
                    <AddAttendeeToClass
                            :booking="booking"
                            @complete="completeAddAttendeeToClass"
                    />
                </v-card-text>

            </v-card>
        </v-dialog>

    </div>
</template>

<script>

    import CreateTrainingClass from "../TrainingClass/Forms/CreateTrainingClass";
    import AddAttendeeToClass from "../TrainingClass/Forms/AddAttendeeToClass";
    import AttendeeListImporter from "../Attendees/AttendeeListImporter";
    import UPDATE_ATTENDEES from "../../graphql/Bookings/UpdateAttendees.gql";
    import {required, email} from 'vee-validate/dist/rules'
    import {extend, ValidationObserver, ValidationProvider, setInteractionMode} from 'vee-validate'

    setInteractionMode('eager')

    extend('required', {
        ...required,
        message: '{_field_} can not be empty',
    })

    extend('email', {
        ...email,
        message: 'Email must be valid',
    })

    export default {
        components: {
            AddAttendeeToClass,
            CreateTrainingClass,
            AttendeeListImporter,
            ValidationProvider,
            ValidationObserver,
        },
        props: {
            booking: Object,
            readonly: {
                type: Boolean,
                default:false
            },
        },
        data() {
            return {
                createNewPrivateClassDialog: false,
                addAttendeeToClassDialog: false,
                importAttendeesDialog: false,
                importAttendees: null,
                createClass: false,
                editClass: false,
                attendeesToDelete: []
            }
        },
        computed: {
            classes() {
                const result = []

                this.booking.attendees.forEach((item, index) => {
                    let tc = this.$_.find(result, {'id': item.trainingClass.id});

                    if (!tc) {
                        tc = this.$_.clone(item.trainingClass)
                        result.push(tc)
                    }

                    if (!Array.isArray(tc.attendees)) {
                        tc.attendees = []
                    }
                    item.bookingIndex = index
                    item.delete = this.attendeesToDelete.indexOf(item.id) !== -1
                    tc.attendees.push(item)
                })

                return result;
            },

            saveParameters() {

                const attendees = {
                    create: [],
                    update: [],
                    delete: this.attendeesToDelete,
                }

                this.booking.attendees.forEach(item => {

                    let newItem = this.$_.pick(item, ['id', 'email', 'firstName', 'lastName', 'labUser', 'labPass', 'trainingClass'])

                    if (!item.id) {
                        attendees.create.push(newItem)
                        newItem.trainingClass = {
                            connect: newItem.trainingClass.id
                        }
                        newItem.booking = {
                            connect: this.booking.id
                        }
                    }

                    if (item.id && this.attendeesToDelete.indexOf(item.id) === -1) {
                        attendees.update.push(newItem)
                        delete newItem.trainingClass
                    }


                })
                return {
                    id: this.booking.id,
                    attendees: attendees,
                };
            },
        },
        methods: {
            openImport(trainingClass) {
                this.importAttendeesDialog = true
                this.importAttendees = trainingClass
            },
            completeCreateTrainingClass() {
                this.createNewPrivateClassDialog = false
                this.$emit('refresh')
            },

            completeAddAttendeeToClass() {
                this.addAttendeeToClassDialog = false
                this.$emit('refresh')
            },

            saveAttendees(classId) {
                this.$refs['observer-' + classId][0].validate().then((valid) => {
                    if (!valid) return

                    this.$apollo.mutate({
                        mutation: UPDATE_ATTENDEES,
                        variables: {input: this.saveParameters},
                    }).then(() => {
                        this.completeCreateTrainingClass()
                        this.editClass = false
                        this.$emit('complete')
                        this.updating = false
                        this.$store.dispatch('notification/addSuccess', 'Attendees Saved Successfully')
                    }).catch((error) => {
                        this.updating = false
                        this.$store.dispatch('notification/handleGraphQlError', error)
                    })
                })
            },

            addAttendee(trainingClass) {
                this.booking.attendees.push({
                    firstName: '',
                    lastName: '',
                    email: '',
                    trainingClass: {
                        id: trainingClass.id,
                        title: trainingClass.title,
                    }
                })
            },

            removeAttendee(bookingIndex) {
                let attendee = this.booking.attendees[bookingIndex]

                if (attendee.id) {
                    this.attendeesToDelete.push(attendee.id)
                } else {
                    this.booking.attendees.splice(bookingIndex, 1)
                }

            },

            unRemoveAttendee(bookingIndex) {
                let index = this.attendeesToDelete.indexOf(this.booking.attendees[bookingIndex].id)
                this.attendeesToDelete.splice(index, 1)
            }

        },
    }
</script>

<style scoped>

</style>
